import { useEffect, useRef, useState } from "react";
import BouncingDiv from "./BouncingDiv";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Home from "./Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Store from "./Store";
import ProductPage from "./ProductPage";
import Videos from "./Videos";
import Music from "./pages/Music";
import { BeFreeSection } from "./pages/BeFreeSection";

function App() {
  console.log("WELCOME TO YUNG MEN'S WEBSITE");
  // console.log(
  //   "IF YOURE SEEING THIS THAT MEANS YOU'RE A BIG CHAD AND DEVELOPER GOOD JOB!"
  // );
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/store",
      element: <Store />,
    },
    {
      path: "/videos",
      element: <Videos />,
    },
    {
      path: "/music",
      element: <Music />,
    },
    {
      path: "/be-free",
      element: <BeFreeSection />,
    },
    {
      path: "/store/item/:id",
      element: <ProductPage />,
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
